import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchPrioritiesService } from '../../../components/Support/services/masterData';

import { createInitialMasterState } from './helpers';
import { PriorityObj } from './support.types';

export const fetchPrioritiesAsyncThunk = createAsyncThunk(
  'supportPriorities/fetchPriorities',
  async (_, { rejectWithValue }) => {
    const { status, statusCode, data, message } =
      await fetchPrioritiesService();
    if (!status || statusCode !== 200 || !data)
      return rejectWithValue(message ?? 'Internal Server Error');
    return data;
  }
);

export const prioritiesSlice = createSlice({
  name: 'supportPriorities',
  initialState: createInitialMasterState<PriorityObj>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPrioritiesAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchPrioritiesAsyncThunk.fulfilled,
        (state, action: PayloadAction<PriorityObj[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchPrioritiesAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = prioritiesSlice.actions;
export default prioritiesSlice.reducer;
